import React, { useState, useEffect } from "react";
import { loadGoogleAnalytics } from "../utils/analytics";
import { useTranslation } from "react-i18next";
import "./CookieConsent.css";

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: true,
    marketing: false,
  });

  const activateScripts = (prefs) => {
    if (prefs.analytics) {
      loadGoogleAnalytics();
    }
  };

  useEffect(() => {
    const savedConsent = localStorage.getItem("cookie-consent-settings");
    if (!savedConsent) {
      setTimeout(() => setIsVisible(true), 1500);
    } else {
      const parsedPrefs = JSON.parse(savedConsent);
      setPreferences(parsedPrefs);
      activateScripts(parsedPrefs);
    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = { essential: true, analytics: true, marketing: true };
    setPreferences(allAccepted);
    localStorage.setItem("cookie-consent-settings", JSON.stringify(allAccepted));
    setIsVisible(false);
    activateScripts(allAccepted);
  };

  const handleDeclineAll = () => {
    const allDeclined = { essential: true, analytics: false, marketing: false };
    setPreferences(allDeclined);
    localStorage.setItem("cookie-consent-settings", JSON.stringify(allDeclined));
    setIsVisible(false);
    activateScripts(allDeclined);
  };

  const handleSavePreferences = () => {
    localStorage.setItem("cookie-consent-settings", JSON.stringify(preferences));
    setIsVisible(false);
    setShowSettings(false);
    activateScripts(preferences);
  };

  const togglePreference = (key) => {
    if (key === "essential") return;
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Se o usuário clicar no link do rodapé, podemos forçar a exibição
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === "#manage-cookies") {
        setIsVisible(true);
        setShowSettings(true);
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  if (!isVisible && !showSettings && !window.location.hash.includes("manage-cookies")) return null;

  return (
    <div className={`cookie-banner ${isVisible ? "show" : ""}`}>
      <div className="cookie-container">
        {!showSettings ? (
          <div className="cookie-main">
            <div className="cookie-text">
              <h4>{t("cookieConsent.title")}</h4>
              <p>
                {t("cookieConsent.descriptionPrefix")} <a href="/privacy">{t("cookieConsent.privacyPolicy")}</a>.
              </p>
            </div>
            <div className="cookie-actions">
              <button className="btn-cookie secondary" onClick={() => setShowSettings(true)}>
                {t("cookieConsent.btnSettings")}
              </button>
              <button className="btn-cookie secondary" onClick={handleDeclineAll}>
                {t("cookieConsent.btnDecline")}
              </button>
              <button className="btn-cookie primary" onClick={handleAcceptAll}>
                {t("cookieConsent.btnAcceptAll")}
              </button>
            </div>
          </div>
        ) : (
          <div className="cookie-settings">
            <h4>{t("cookieConsent.settingsTitle")}</h4>
            <div className="settings-list">
              <div className="setting-item">
                <div className="setting-info">
                  <strong>{t("cookieConsent.essentialTitle")}</strong>
                  <p>{t("cookieConsent.essentialDesc")}</p>
                </div>
                <label className="switch">
                  <input type="checkbox" checked={preferences.essential} disabled readOnly />
                  <span className="slider round"></span>
                </label>
              </div>

              <div className="setting-item">
                <div className="setting-info">
                  <strong>{t("cookieConsent.analyticsTitle")}</strong>
                  <p>{t("cookieConsent.analyticsDesc")}</p>
                </div>
                <label className="switch">
                  <input type="checkbox" checked={preferences.analytics} onChange={() => togglePreference("analytics")} />
                  <span className="slider round"></span>
                </label>
              </div>

              <div className="setting-item">
                <div className="setting-info">
                  <strong>{t("cookieConsent.marketingTitle")}</strong>
                  <p>{t("cookieConsent.marketingDesc")}</p>
                </div>
                <label className="switch">
                  <input type="checkbox" checked={preferences.marketing} onChange={() => togglePreference("marketing")} />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="cookie-actions mt-3">
              <button className="btn-cookie secondary" onClick={() => setShowSettings(false)}>
                {t("cookieConsent.btnBack")}
              </button>
              <button className="btn-cookie primary" onClick={handleSavePreferences}>
                {t("cookieConsent.btnSave")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookieConsent;
